import loaded from '@/scripts/utils/loaded';

function classHelper(els, action, className) {
    if (!els) return
    var map = {
        c: 'contains',
        a: 'add',
        r: 'remove'
    }
    var checkEl = function (el) {
        if (!el.classList) return
        if (action === 'c') {
            return el.classList[map[action]](className)
        }
        if (action === 'r') {
            if (el.classList) el.classList.remove(className)
            return
        }
        el.classList[map[action]](className)
    }

    if (action === 'c' || !(els instanceof NodeList)) return checkEl(els)
    for (var i = 0; i < els.length; i++) checkEl(els[i])
}

function debounce(func, wait, immediate) {
    var timeout
    return function () {
        var context = this, args = arguments
        var later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        var callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, 100)
        if (callNow) func.apply(context, args)
    }
}

function searchCloseAll() {
    if (!getEl('.search-shopify-header.active')) return
    classHelper(getEl('.search-shopify-header, .search-shopify-header .search-form, .search-shopify-header .results', 1), 'r', 'active')
    classHelper(getEl('body'), 'r', 'search-no-scroll')
    document.activeElement.blur()
}

function headerSearchResultsShowHide(parentEl, hide) {
    const resultsDiv = getChild(parentEl, '.results')
    classHelper(resultsDiv, hide ? 'r' : 'a', 'active')
}

function headerGetResults(q, cb) {
    const uri = `${window.Theme.routes.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(q)}&section_id=predictive-search-header-results-section&resources[options][unavailable_products]=hide&resources[limit_scope]=all&resources[type]=product,page,article,collection,query`
    fetch(uri)
        .then((response) => {
            if (!response.ok) throw Error(response)
            return response.text()
        })
        .then((text) => {
            cb(text)
        })
        .catch((e) => {
            throw Error(e)
        })
}

function filterItems(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html')
    for (const type in psSettings.filter) {
        const filterVals = psSettings.filter[type]
        if (!filterVals.length) continue
        for (const fv of filterVals) {
            const uls = getChild(doc, '#predictive-search-results ul', 1)
            for (let i = 0; i < uls.length; i++) {
                const ul = uls[i]
                const lis = getChild(ul, '#predictive-search-results li', 1)
                let removals = 0
                for (let n = 0; n < lis.length; n++) {
                    const li = lis[n]
                    const thisVal = li.getAttribute('data-item_' + type)
                    if (!thisVal) continue
                    const regex = new RegExp(fv, 'i')
                    if (thisVal.match(regex)) {
                        li.remove()
                        removals++
                    }
                }
                if (removals && removals === lis.length) {
                    ul.previousElementSibling.remove()
                    ul.remove()
                }
            }
        }
    }
    return getChild(doc, '#predictive-search-results')
}

function headerSearchResultsHandler(form, q) {
    headerGetResults(q, (html) => {
        const nodes = filterItems(html)

        const parentEl = getParent(form, 'search-shopify-header')
        const resultsEl = getChild(parentEl, '.results')
        const resultsInner = getChild(parentEl, '.results > .inner')
        resultsInner.innerHTML = ''
        resultsInner.appendChild(nodes)
        headerSearchResultsShowHide(parentEl)
        classHelper(getEl('body'), 'a', 'search-no-scroll')

        if (window.innerWidth <= psSettings.mobileBreakpoint) {
            resultsEl.style.top = (form.offsetHeight + form.getBoundingClientRect().top) + 'px';
        }
    })
}

function headerSearchInputChange(input) {
    const headerInputEventHandler = debounce((e) => {
        if (e.keyCode === 27) return
        const form = getParent(e.target, 'FORM', true)
        const q = e.target.value
        if (q) headerSearchResultsHandler(form, q)
    })

    input.addEventListener('keyup', headerInputEventHandler)
}

function headerSearchOffEvents() {
    document.addEventListener('keyup', function (e) {
        if (e.keyCode === 27) {
            searchCloseAll();
        }
    })
    document.addEventListener('click', function (e) {
        const searchEl = getParent(e.target, 'search-shopify-header')
        if (searchEl) {
            return;
        }

        searchCloseAll()
    })
}

function headerSearchIconEvents(el) {
    const searchIcon = getChild(el, '.icon')
    searchIcon.addEventListener('click', function (e) {
        e.preventDefault()
        const parentEl = getParent(e.target, 'search-shopify-header')
        classHelper(parentEl, 'a', 'active')
        const searchForm = getChild(parentEl, '.search-form')
        classHelper(searchForm, 'a', 'active')
        const input = getChild(searchForm, 'input[name="q"]')
        input.setAttribute('tabindex', '0')
        input.focus()
    })
    const closeEl = getChild(el, '.close')
    closeEl.addEventListener('click', function (e) {
        e.preventDefault()
        searchCloseAll()
    })
}

function headerSearchResultsTopPosition(parentEl) {
    const input = getChild(parentEl, 'input[name="q"]')
    const resultsEl = getChild(parentEl, '.results')
    resultsEl.style.top = input.offsetHeight + 'px'
}

function headerSearchEvents() {
    const searchHeaderEls = getEl('.search-shopify-header', 1)
    for (let i = 0; i < searchHeaderEls.length; i++) {
        headerSearchIconEvents(searchHeaderEls[i])
        const form = getChild(searchHeaderEls[i], 'form')
        const thisInput = getChild(form, 'input[name="q"]')
        headerSearchInputChange(thisInput)

        thisInput.addEventListener('focus', function (e) {
            headerSearchResultsTopPosition(getParent(e.target, 'search-shopify-header'))
            const formFromFocus = getParent(e.target, 'FORM', true)
            const qFromFocus = e.target.value
            const defaultQ = psSettings.defaultQuery || '*'
            headerSearchResultsHandler(formFromFocus, qFromFocus || defaultQ)
        })

        form.addEventListener('submit', function (e) {
            e.preventDefault()
            const thisForm = e.target
            const qEl = getChild(thisForm, 'input[name="q"]')
            location.href = `/search?type=product&q=${qEl.value ? encodeURIComponent(qEl.value) : '*'}`
        })
    }
    headerSearchOffEvents()
}

function headerSearchInit() {
    headerSearchEvents()
}

loaded(headerSearchInit)
